'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * Loader styles are available via the loader.scss file, loader.css or all.css files.
 *
 * Usage:
 *
 * ```Javascript
 * <Loader loading />
 * ```
 *
 * @extends {React.Component}
 * @property {Boolean} loading Renders the loader spin over the component.
 */
class Loader extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getSpinnerClassName (loading) {
    return classNames({
      'LoadingIndicator-overlay': true,
      'Left-0': true,
      'is-active': loading
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      <div>
        <div className='LoadingIndicator'>
          <div className={this.getSpinnerClassName(this.props.loading)}>
            <div className='LoadingIndicator-segments'>
              <div className='LoadingIndicator-segment LoadingIndicator-segment--one'></div>
              <div className='LoadingIndicator-segment LoadingIndicator-segment--two'></div>
              <div className='LoadingIndicator-segment LoadingIndicator-segment--three'></div>
              <div className='LoadingIndicator-segment LoadingIndicator-segment--four'></div>
              <div className='LoadingIndicator-segment LoadingIndicator-segment--five'></div>
            </div>
            <div className='LoadingIndicator-message'>Loading...</div>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Loader component
 */
Loader.propTypes = {
  loading: React.PropTypes.bool
};

Loader.defaultProps = {
  loading: false
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/loader.jsx